import React from 'react';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';

import { Messages } from '../../../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../../../sessionManagement/SessionManagementService';
import { GeneralServerSettingsSubspaceState } from '../../../components/subspaces/ServerSettingsSpace/GeneralServerSettingsSubspace';
import { coordinatorSubmitFailedHandler, coordinatorSubmitHandler } from '../common/GeneralToastHandlers';
import ReactSiteSettingsForServerAdmin from '../site-settings/ReactSiteSettingsForServerAdminSubFormik';
import { ReactSiteSettingsForSiteAdmin } from '../site-settings/ReactSiteSettingsForSiteAdminSubFormik';
import { ReactServerSettings } from './ReactServerSettingsSubFormik';

export function GeneralServerSettingsCoordinator(props: GeneralServerSettingsSubspaceState) {
  const sessionService = getSessionManagementServiceInstance();

  return (
    <SettingsCoordinator
      onSubmit={coordinatorSubmitHandler}
      onSubmitFailure={coordinatorSubmitFailedHandler}
      onResetToDefaultSuccess={showResetSuccessToast}
      showResetToDefaultButton={true}
    >

      {!sessionService.doesTheServerHaveMoreThanOneSite() &&
      <ReactSiteSettingsForServerAdmin settings={props}/>}

      {!sessionService.doesTheServerHaveMoreThanOneSite() &&
      <ReactSiteSettingsForSiteAdmin settings={props}/>}

      <ReactServerSettings
        settings={props.serverSettings}
        serverTimestamps={props.serverTimestamps}
      />
    </SettingsCoordinator>
  );
}

async function showResetSuccessToast() {
  ToasterService.getInstance().pop({type: ToastType.Info, text: Messages.resetServerSettingsSuccess()});
}
